/* eslint-disable eqeqeq */
import React from "react";
import { useSelector } from "react-redux";
import CustomDropdown from "../../../../Core/Components/CustomDropdown";
import getActivities from "../getActivities";
import getActivityTag from "../getActivityTag";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";

const ActivitySelector = ({
  data,
  open,
  setOpen,
  activity,
  totalLength,
  handleClick,
}) => {
  const { stops, validationForSteps } = useSelector((state) => state.trips);

  const disabled = data.id === 1 || data.id === totalLength;

  const getBody = () => {
    if (data.id === 1 || data.id === totalLength) {
      return (
        <p className="text-xs font-semibold capitalize text-dark-grey font-aileron">
          None
        </p>
      );
    }

    if (activity?.key === 1) {
      return (
        <p className="text-xs font-semibold text-black capitalize font-aileron">
          Select an Activity
        </p>
      );
    }

    return getActivityTag(activity?.key || 0);
  };

  const renderBorderColorForActivity = () => {
    if (data.id !== 1 && data.id !== totalLength) {
      if (open) return "border border-primary";

      if (
        validationForSteps.step1.activity.includes(data.id) &&
        activity.key === 1
      )
        return "border border-alert-red";
    }
    return "border border-light-grey";
  };

  return (
    <CustomDropdown
      trigger={["click"]}
      // items={activities}
      items={getActivities({ stops, id: data.id })}
      disabled={disabled}
      dropDownOpen={open}
      onOpenChange={(flag) => setOpen(flag)}
      handleClick={handleClick}
    >
      <div>
        <p className="text-xs font-normal capitalize font-aileron text-dark-gray">
          Activity
        </p>

        <div
          className={`mt-1 w-full rounded-md border py-2 px-3.5 h-9.5 flex items-center justify-between cursor-pointer
                    ${renderBorderColorForActivity()}
                    ${disabled ? "bg-new-gray" : ""}`}
        >
          {getBody()}
          <ChevronIcon
            className={`w-5 h-5 transform transition-all duration-200 ${
              disabled ? "stroke-light-grey" : "stroke-dark-gray"
            }
                      ${open ? "-rotate-90" : "rotate-90"}
                      `}
          />
        </div>
      </div>
    </CustomDropdown>
  );
};

export default ActivitySelector;
